// Ist eigentlich eine Datenbanktabelle - sollte da was dazu kommen muss hier auch angepasst werden

export enum MediumPricat
{
	None = 0,
	ExiteLink = 1,
    FTP_S = 2,
	HogastGateway = 3,
	HogastHandoverGateway = 4,
    HogastGastropoolGateway = 5,
	HogastGermanyGateway = 6,
	SFTP = 7,
    Exite_FTP_S = 8
}